import { Component } from '@angular/core';
import {AlertController, NavController, NavParams, Platform, ViewController} from 'ionic-angular';
import { FormGroup } from "@angular/forms";
import { XpReportCustomerClientPage } from "../xp-report-customer-client/xp-report-customer-client";
import { BarcodeScannerService } from "../../services/barcode-scanner.service";
import {XpWorkorderService} from "../../services/xp-workorder.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'page-xp-report-search-location',
  templateUrl: 'xp-report-search-location.html',
})
export class XpReportSearchLocationPage {

  searchPerformed = false;
  busy = false;
  clientForm: FormGroup;
  locationForm: FormGroup;
  invoiceForm: FormGroup;
  externalForm: FormGroup;
  page: XpReportCustomerClientPage;
  data: any;

  searchType = 1;
  query = '';
  zipcode = '';
  number = '';
  locations = [];

  dummyData = [
    {
      "list_title": "T. van der Test",
      "list_subtitle": "Teststraat 1, 1234 AB, Teststad - NL22M00000870665105",
    }
  ];

  dummyDataBe = [
    {
      "list_title": "T. van der Test",
      "list_subtitle": "Teststraat 1, 1234, Teststad - BE22M00000870665105",
    }
  ];

  dummyDataUy = [
    {
      "list_title": "P. Prueba",
      "list_subtitle": "Calle de Prueba 1, 1234, Ciudad de Prueba - UY22M00000870665105",
    }
  ];

  dummyDataUyEn = [
    {
      "list_title": "Mr. Test",
      "list_subtitle": "Test street 1, 1234, Test city - UY22M00000870665105",
    }
  ];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public barcodeScanner: BarcodeScannerService,
    public platform: Platform,
    public translate: TranslateService,
    public workorderService: XpWorkorderService
  ) {
    this.clientForm = navParams.get('clientForm');
    this.locationForm = navParams.get('locationForm');
    this.invoiceForm = navParams.get('invoiceForm');
    this.externalForm = navParams.get('externalForm');
    this.page = navParams.get('page');
    this.data = navParams.get('data');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportSearchLocationPage');
  }

  isValid(){
    if(
      (this.searchType === 1 && this.query.trim()) ||
      (this.searchType === 2 && this.zipcode.trim() && this.number.trim())

    ){
      return true;
    }
    return false;
  }

  scanBarcode(){
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      // Detect appstore QR codes
      if(
        barcode.indexOf('https://apps.apple.com/') !== -1 ||
        barcode.indexOf('https://play.google.com/') !== -1
      ){
        this.alertCtrl.create({
          message: this.translate.instant("U heeft de Maintenanz App reeds gedownload. Scan de QR code van de 'installatiepas' om de klant- en installatie gegevens op te halen."),
          buttons: ['OK']
        }).present();
        return;
      }
      // Detect invalid QR code
      if(
        barcode.indexOf('https://mntnz.nl/') === -1 &&
        barcode.length !== 19
      ){
        this.alertCtrl.create({
          message: this.translate.instant("Dit is geen QR code van een installatie. Scan de QR code van de 'installatiepas' om de klant- en installatie gegevens op te halen."),
          buttons: ['OK']
        }).present();
        return;
      }
      // Strip url
      if(barcode.lastIndexOf('/') > 0) {
        barcode = barcode.substring(barcode.lastIndexOf('/') + 1);
      }
      if(barcode){
        this.query = barcode;
        this.search(3);
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  search(searchType?){
    this.searchPerformed = false;
    this.locations = [];
    this.busy = true;
    setTimeout(() => {
      // @ts-ignore
      if(this.workorderService.getCountry() === 'BE'){
        this.locations = this.dummyDataBe;
      } else if(this.workorderService.getCountry() === 'UY') {
        if(this.translate.currentLang === 'en') {
          this.locations = this.dummyDataUyEn;
        } else {
          this.locations = this.dummyDataUy;
        }
      } else {
        this.locations = this.dummyData;
      }
      this.busy = false;
      this.searchPerformed = true;
    }, 1500);
  }

  select(location){
    let dummyData = this.workorderService.getDummyData(this.data.workorder_type);
    location = dummyData.location;
    location.customers = dummyData.customers;
    location._same_as_client = 0;
    location._requires_action = '0';
    this.page.locationExpanded = false;
    this.locationForm.patchValue(location);
    this.locationForm.markAsPristine();
    if(location.customers && location.customers.client){
      location.customers.client._requires_action = '1';
      if(location.customers.client.terms_agreed && location.customers.client.terms_agreed === '1'){
        location.customers.client.terms_agreed = true;
      }
      this.clientForm.patchValue(location.customers.client);
      this.page.clientRequiresAction = '1';
      this.clientForm.markAsPristine();
    }
    this.data.location = location;
    this.data.customers = location.customers;
    this.data._selected_location = location;
    this.data._selected_customers = location.customers;
    Object.assign(this.data, this.workorderService.getDummyData(this.data.workorder_type));
    this.closeModal();
  }

  closeModal(){
    this.page.fixIonSelects();
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-report-search-location/xp-report-search-location.ts